import { Outlet } from "react-router-dom";

const CustomFieldLayout = () => {
  return <Outlet />;
};

export default CustomFieldLayout;